/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IMigrateLegacyRepoMutationVariables = Types.Exact<{
  legacyRepoId: Types.Scalars['ID']['input'];
  integrationId: Types.Scalars['ID']['input'];
  oauthRepoId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type IMigrateLegacyRepoMutation = {
  __typename?: 'Mutation';
  migrateLegacyRepo?: {
    __typename?: 'MigrateLegacyRepoPayload';
    success: boolean;
    errors?: Array<string> | null;
  } | null;
};

export const MigrateLegacyRepoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'migrateLegacyRepo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'legacyRepoId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oauthRepoId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'migrateLegacyRepo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'legacyRepoId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'legacyRepoId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'integrationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'oauthRepoId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'oauthRepoId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IMigrateLegacyRepoMutation, IMigrateLegacyRepoMutationVariables>;
